const setData = (state, action) => {
  Object.entries(action.payload).forEach(([key, value]) => {
    state[key] = value
  })
  return state
}

const reducers = {
  setData,
}

export default reducers
